/**
 * The API's base address ('' on the web: same origin, or VITE_API_URL).
 *
 * Read it through this function at every call, never copy it into a
 * module-level constant: on mobile the address is chosen at runtime (the
 * organization code the user enters at first launch) and can change while
 * the app runs ("Schimbă organizația"). There `import.meta.env.VITE_API_URL`
 * is a getter over the saved server (mobile/src/platform/polyfills.ts); on
 * the web Vite inlines the build-time value, so nothing changes.
 *
 * mobile/tools/pending.sh fails when VITE_API_URL is read anywhere else.
 */
export function apiBase(): string {
  return (import.meta.env.VITE_API_URL as string | undefined) ?? '';
}
